import { useT } from "@repo/transifex";
import { ReportCard, ReportPriceRow } from "~/components/report";
import { useVatLabel } from "~/hooks/use-vat-label";

import { type RefundsSectionData } from "./types";
import { negatePrice } from "./utils";

type RefundsSectionProps = {
  data: RefundsSectionData;
};

export const RefundsSection = ({ data }: RefundsSectionProps) => {
  const t = useT();
  const { vatLabel } = useVatLabel();

  const visibleBreakdown = data.breakdown.filter((item) => item.amount !== 0);

  return (
    <ReportCard title={t("Refunds (incl. {vatLabel})", { vatLabel })}>
      {visibleBreakdown.map((item) => (
        <ReportPriceRow
          key={item.label}
          label={item.label}
          value={negatePrice(item.amount)}
          currency={data.currency}
        />
      ))}
      <ReportPriceRow
        label={t("TOTAL")}
        value={negatePrice(data.totalRefunds)}
        currency={data.currency}
        variant="bold"
      />
    </ReportCard>
  );
};
